import React, { useEffect, useState } from 'react';

import { Button } from "../../buttons";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import RichText from "../../../lib/contentful/rich-text";
import CalendarIcon from '../../../lib/fontawesome/CalendarIcon';
import { Swiper, SwiperSlide } from "swiper/react";

import { unstable_batchedUpdates } from 'react-dom';
import SimpleBanner from "../../banner-block/simple-banner";
import { Navigation, Lazy, A11y } from "swiper";
import getEvents from '../../../api/arlo/getEvents';
import getEventTemplates from '../../../api/arlo/getEventTemplates';
import getFilters from '../../../api/arlo/getFilters';

import InstallersPlaceholder from "../../../images/installers-placeholder.png";

import * as styles from "./index.module.scss";
import { Modal } from '../../modal';

import User from '../../../images/user.png';
import LocationPin from '../../../images/svgs/icons/location-pin.svg';

const ExpertAcademyIntroduction = ({
    backgroundColour = "#000",
    textColour = "#FFF",
    mainTitle,
    mainSubtitle,
    mainText,
    mainSupportingImage,
    button,
    secondaryTitle,
    secondaryContent,
    secondarySupportingImages,
    secondaryCtaButton,
    bottomBanner,
    relatedBlogPosts
}) => {
    const [slides, setSlides] = useState(4);
    const [eventsSlides, setEventsSlides] = useState(4);
    const [loop, setLoop] = useState(false);
    const [navigation] = useState(true);
    const [centerSlides, setCenterSlides] = useState(false);
    const [eventTemplates, setEventTemplates] = useState([]);
    const [events, setEvents] = useState([]);
    const [eventLocationFilters, setEventLocationFilters] = useState([]);
    const [filters, setFilters] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState({ID: 0});
    const [selectedEventLocationFilter, setSelectedEventLocationFilter] = useState({ID: 0});
    const [loading, setLoading] = useState(true);
    const [extended, setExtended] = useState(false);
    const [selectedEventTemplate, setSelectedEventTemplate] = useState(null);
    const [loadingEvents, setLoadingEvents] = useState(true);

    const formatDateAsTitle = (dateTimeString) => {
        const date = new Date(dateTimeString);
    
        const weekday = date.toLocaleString('en-GB', { weekday: 'short' });
        const day = date.toLocaleString('en-GB', { day: 'numeric' });
        const month = date.toLocaleString('en-GB', { month: 'short' });
    
        return `${weekday} ${day} ${month}`;
    }    

    const formatDate = (dateTimeString) => {
        const date = new Date(dateTimeString);

        const day = date.toLocaleString('en-GB', { day: 'numeric' });
        const month = date.toLocaleString('en-GB', { month: 'short' });
        const time = date.toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

        return `${day} ${month} ${time}`;
    }

    useEffect(() => {
        const fetchFilters = async () => {
            const fetchedFilters = await getFilters();
            setFilters(fetchedFilters?.data);
        };

        fetchFilters();
    }, []);

    useEffect(() => {
        setLoading(true);

        const finishLoading = () => {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }

        const fetchEvents = async () => {
            const fetchedEvents = await getEventTemplates(selectedFilter);
            if (fetchedEvents?.data?.Items && fetchedEvents?.data?.Items.length > 0) {
                setEventTemplates(fetchedEvents?.data?.Items);
                finishLoading();
            } else {
                setEventTemplates([]);
                finishLoading();
            }
        };
    
        fetchEvents();
    }, [selectedFilter]);

    useEffect(() => {
        setLoadingEvents(true);

        const finishLoading = () => {
            setTimeout(() => {
                setLoadingEvents(false);
            }, 500);
        }

        const fetchFilteredEvents = async () => {
            const fetchedEvents = await getEvents(selectedEventTemplate, selectedEventLocationFilter);
            if (fetchedEvents?.events?.Items && fetchedEvents?.events?.Items.length > 0) {
                setEvents(fetchedEvents?.events?.Items);
                finishLoading();
            } else {
                setEvents([]);
                finishLoading();
            }
        };

        fetchFilteredEvents();
    }, [selectedEventLocationFilter]);

    useEffect(() => {
        setLoadingEvents(true);

        const finishLoading = () => {
            setTimeout(() => {
                setLoadingEvents(false);
            }, 500);
        }

        const fetchEvents = async () => {
            const fetchedEvents = await getEvents(selectedEventTemplate);
            if (fetchedEvents?.events?.Items && fetchedEvents?.events?.Items.length > 0) {
                setEvents(fetchedEvents?.events?.Items);

                if (fetchedEvents?.locations && fetchedEvents?.locations.length > 0) {
                    setEventLocationFilters(fetchedEvents?.locations);
                    finishLoading();
                } else {
                    setEventLocationFilters([]);
                    finishLoading();
                }
            } else {
                setEvents([]);
                setEventLocationFilters([]);
                finishLoading();
            }
        };
    
        fetchEvents();
    }, [selectedEventTemplate]);

    const resize = e => {
        unstable_batchedUpdates(() => {
            if (window.innerWidth <= 768) {
                setSlides(1);
                setEventsSlides(2);
                setLoop(true);
                setCenterSlides(true);
            } else if ((window.innerWidth <= 991) && (window.innerWidth > 768)) {
                setSlides(2);
                setEventsSlides(2);
                setLoop(true);
                setCenterSlides(false);
            } else {
                setSlides(4);
                setEventsSlides(4);
                setLoop(false);
                setCenterSlides(false);
            }
        });
    }

    const EventCard = ({ event }) => (
        <div className={`${styles.whitetext} ${styles.eventCard}`}>
            <div className={`${styles.blogCardTop} ${styles.courseCard}`}>
                <a href={event?.ViewUri} target="_blank" rel="noopener noreferrer" className={`${styles.blogCardLinkWrapper} ${styles.cardText}`}>
                    <strong>{formatDateAsTitle(event?.StartDateTime)}</strong>
                    <span>{formatDate(event?.StartDateTime)} - {formatDate(event?.EndDateTime)}</span>
                    <div className={styles.eventCardMeta}>
                        <div className={styles.eventCardMetaItem}>
                            <img src={LocationPin} alt={event?.Location['City']}/>
                            <span>{event?.Location['City']}</span>
                        </div>
                        <div className={styles.eventCardMetaItem}>
                            <img 
                                src={User} 
                                alt={
                                    event?.Presenters?.length > 0
                                        ? `Presented by ${event.Presenters.map((presenter) => presenter['Name']).join(', ')}`
                                        : 'An event by Ideal Heating'}
                            />
                            <span>Presented by {event?.Presenters?.map((presenter, index) => presenter['Name']).join(', ')}</span>
                        </div>
                    </div>
                    <span className={styles.eventCTA}>View Event</span>
                </a>
            </div>
        </div>
    );

    const EventTemplateCard = ({ event }) => (
        <div className={`${styles.whitetext} ${styles.eventCard}`} onClick={() => setSelectedEventTemplate(event)}>
            <div 
                className={`${styles.blogCardTop} ${styles.courseCard}`} 
                style={{
                    backgroundImage: `url(${event?.Media?.["Template.ListImage"] ? event?.Media?.["Template.ListImage"]?.Uri : InstallersPlaceholder})`,
                }}
            >
                <div className={`${styles.blogCardLinkWrapper} ${styles.cardText}`}>
                    <strong>{event?.Name}</strong>
                </div>
                <span className={`${styles.eventCTA} ${styles.cardText}`}>Learn More</span>
            </div>
        </div>
    );

    const LoadingCard = ({ index }) => (
        <div className={styles.whitetext} key={`loading-card-${index}`}>
            <div className={`${styles.blogCardTop} ${styles.courseCard} ${styles.loadingCard}`}>
                <div className={`${styles.searchBarSpinner} ${styles.spinning}`}></div>
            </div>
        </div>
    );

    const Grid = ({ children }) => (
        <div className={`${styles.cardGrid} ${styles.eventGrid} ${extended ? styles.cardGridExtended : null}`}>
            {children}
            {eventTemplates.length > 4 && !extended && (
                <div className={`${styles.cardGridButton} ${styles.button}`}>
                    <Button 
                        content={"Load more"}
                        clickEvent={() => setExtended(true)}
                        elementType={`button`}
                    ></Button>
                </div>
            )}
            {extended && (
                <div className={`${styles.cardGridButton} ${styles.button}`}>
                    <Button 
                        content={"View all"}
                        href="https://www.expert-academy.co.uk/w/courses/"
                        opensNewTab={true}
                    ></Button>
                </div>
            )}
        </div>
    );

    const EventsGrid = ({ children }) => (
        <div className={`${styles.cardGrid} ${styles.eventGrid} ${styles.cardGridExtended} ${styles.modalGrid}`}>
            {children}
            <div className={`${styles.cardGridButton} ${styles.button}`}>
                <Button 
                    content={"View all"}
                    href={selectedEventTemplate?.ViewUri ? selectedEventTemplate.ViewUri : `https://www.expert-academy.co.uk/w/courses/`}
                    opensNewTab={true}
                ></Button>
            </div>
        </div>
    );

    const LoadingModal = () => (
        <div className={styles.loadingModal}>
            <div className={`${styles.searchBarSpinner} ${styles.spinning}`}></div>
        </div>
    );
    
    const LoadingGrid = ({ children }) => (
        <div className={styles.cardGrid}>
            {children}
        </div>
    );    

    useEffect(() => {
        window.addEventListener('resize', resize);

        resize();

        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [])

    return (
        <section
            className={styles.wrapper}
            style={{
                backgroundColor: backgroundColour,
                color: textColour
            }
        }>
            <div className={`${styles.container} ${styles.containerOverflow}`}>
                <div className={`${styles.content}`}>
                    <h2 className='h1'>{mainTitle}</h2>
                    <h3>{mainSubtitle}</h3>
                    {RichText(mainText)}
                    <div className={styles.button}>
                        <Button
                            colorData={`green`}
                            typeData={`default`}
                            href={button?.url}
                            content={button?.text}
                            alt={button?.text}
                            target={button?.openInNewTab === true ? `_blank` : null}
                        />
                    </div>
                </div>
                <div className={`${styles.imageSection} ${styles.oneImage}`}>
                    <div className={`${styles.images} ${styles.columnOne}`}>
                        <GatsbyImage
                            image={getImage(mainSupportingImage)}
                            className={styles.image}
                        />
                    </div>
                </div>
            </div>
            <div className={`${styles.container} ${styles.courseContainer}`}>
                <h3>Looking for in-person training? Explore our courses</h3>
                <div className={styles.filterBar}>
                    {filters && filters.length > 0 ? (
                        filters.map((filter, index) => (
                            <Button 
                                key={`event-filter-${index}`}
                                elementType={`button`}
                                content={filter.Name} 
                                clickEvent={() => setSelectedFilter(filter)}
                                selected={selectedFilter?.ID === filter.ID}
                                filter={true}
                            ></Button>
                        ))
                    ) : null}
                </div>
                {!loading && (
                    (eventTemplates && eventTemplates.length > 0) ? (
                        <>
                            <Swiper
                                slidesPerView={eventsSlides}
                                navigation={true}
                                loop={loop}
                                modules={[Navigation, Lazy, A11y]}
                                centeredSlides={centerSlides}
                                className={`${styles.slider} ${styles.eventSlider}`}
                                spaceBetween={20}
                            >
                                {eventTemplates.map((event, index) => (
                                    <SwiperSlide key={event.id || `event-${index}`}>
                                        <EventTemplateCard event={event} key={`template-card-mobile-${index}`} index={index} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className={`${styles.cardGridButton} ${styles.button} ${styles.sliderButton}`}>
                                <Button 
                                    content={"View all"}
                                    href="https://www.expert-academy.co.uk/w/courses/"
                                    opensNewTab={true}
                                ></Button>
                            </div>
                        </>
                    ) : (
                        !loading && <p className={styles.eventSlider}>No events available, please try selecting a different category.</p>
                    )
                )}
                {!loading && (
                    (eventTemplates && eventTemplates.length > 0) ? (
                        <Grid>
                            {eventTemplates.map((event, index) => (
                                <EventTemplateCard event={event} key={`template-card-${index}`} index={index} />
                            ))}
                        </Grid>
                    ) : (
                        !loading && <p className={styles.eventGrid}>No events available, please try selecting a different category.</p>
                    )
                )}
                {loading ? (
                    <LoadingGrid>
                        <LoadingCard index={0} />
                        <LoadingCard index={1} />
                        <LoadingCard index={2} />
                        <LoadingCard index={3} />
                    </LoadingGrid>
                ) : null}
            </div>
            <div className={styles.container}>
                <div className={`${styles.content}`}>
                    <h2 className='h1'>{secondaryTitle}</h2>
                    <iframe width="100%" height="315" src="https://www.youtube.com/embed/aN6jwqIpiQs?si=UoAS1aEjpc8peyk_" title="An introduction to Expert Academy" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    {RichText(secondaryContent)}
                    <div className={styles.button}>
                        <Button
                            colorData={`green`}
                            typeData={`default`}
                            href={secondaryCtaButton?.url}
                            content={secondaryCtaButton?.text}
                            alt={secondaryCtaButton?.text}
                            target={secondaryCtaButton?.openInNewTab === true ? `_blank` : null}
                        />
                    </div>
                </div>
                <div className={styles.imageSection}>
                    <div className={`${styles.images} ${styles.columnOne}`}>
                        {secondarySupportingImages.map((imageData, index) => (
                            <GatsbyImage
                                key={index}
                                image={getImage(imageData.gatsbyImageData)}
                                alt={`Supporting image ${index + 1}`}
                                className={styles.image}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <Modal visible={selectedEventTemplate !== null} setVisible={() => setSelectedEventTemplate(null)} size='fullscreen' background='#000' text='#fff' closeButtonColour="#fff">
                <div className={styles.modalTitle}>
                    {selectedEventTemplate?.Name && <h3>{selectedEventTemplate.Name}</h3>}
                    {selectedEventTemplate?.Description && <p>{selectedEventTemplate.Description['Summary']}</p>}
                    {eventLocationFilters && <div className={styles.filterBar}>
                        {eventLocationFilters.map((filter, index) => (
                            <Button 
                                key={`event-location-filter-${index}`}
                                elementType={`button`}
                                content={filter.Name} 
                                clickEvent={() => setSelectedEventLocationFilter(filter)}
                                selected={selectedEventLocationFilter?.ID === filter.ID}
                                filter={true}
                            ></Button>
                        ))}
                    </div>}
                </div>
                {loadingEvents ? <LoadingModal /> : null}
                {!loadingEvents && (events && events.length > 0) ? (
                    <EventsGrid>
                        {events.map((event, index) => (
                            <EventCard event={event} key={`event-card-${index}`} index={index} />
                        ))}
                    </EventsGrid>
                ) : (
                    !loadingEvents && selectedEventTemplate !== null && <p className={`${styles.eventGrid} ${styles.modalNoResults}`}>No events available. Click <a className={styles.eventClickMore} href={selectedEventTemplate?.ViewUri} target="_blank" rel="noopener noreferrer"> here </a> to register your interest.</p>
                )}
                {!loadingEvents && <div className={`${styles.cardGridButton} ${styles.button}`}>
                    
                </div>}
            </Modal>
            <div className={styles.container}>
                <SimpleBanner {...bottomBanner} backgroundImage={bottomBanner?.backgroundImage?.file?.url} slim={true} ctaLink={bottomBanner?.ctaAsset?.download?.publicUrl ?? bottomBanner?.ctaLink} />
            </div>
            <div className={styles.container}>
                <Swiper
                    slidesPerView={slides}
                    navigation={navigation}
                    loop={loop}
                    modules={[Navigation, Lazy, A11y]}
                    centeredSlides={centerSlides}
                    className={styles.slider}
                    spaceBetween={20}
                >
                    {relatedBlogPosts.map((relatedBlogPosts, index) => (
                        <SwiperSlide key={`blog-item-${index}`}>
                            <div className={`${styles.whitetext} ${styles.fullHeightCard}`}>
                                <div className={styles.blogCardTop}>
                                    <a href={'/blog/'+relatedBlogPosts.slug} className={styles.blogCardLinkWrapper}>
                                        <GatsbyImage image={getImage(relatedBlogPosts.image)} objectFit="cover" alt={relatedBlogPosts.image?.title} />
                                    </a>
                                </div>
                                <div className={styles.blogCardBottom}>
                                    <a href={'/blog/'+relatedBlogPosts.slug} className={styles.blogCardLinkWrapper}>
                                        <h3 className={styles.blogCardBottomTitle}>{relatedBlogPosts.title}</h3>
                                    </a>
                                    {relatedBlogPosts.categories.map((categories, index) => (
                                        <div className={styles.blogMeta}>
                                            <span className={styles.blogMetaDate}><CalendarIcon fill='#fff' title='Publication date' className={styles.icon} />{relatedBlogPosts.publishDate}</span>
                                        </div>
                                    ))}
                                    <a href={'/blog/'+relatedBlogPosts.slug} className={styles.blogCardLinkWrapper}></a>
                                    <span className={styles.blogCardBottomContent}>{relatedBlogPosts.description.description}</span>
                                    <a className={styles.blogCardBottomReadMore} href={'/blog/'+relatedBlogPosts.slug}>Read more</a>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}

export default ExpertAcademyIntroduction;